import { Component } from 'react';
import type { ErrorInfo } from 'react';

import { ErrorDisplay } from '../ErrorDisplay';

const initialState = {
    error: null as null | Error,
};

export class GlobalErrorBoundary extends Component<GlobalErrorBoundary.Props, GlobalErrorBoundary.State> {
    state = initialState;

    private promiseRejectionHandler = (event: PromiseRejectionEvent) => {
        this.setState({
            error: event.reason,
        });
    };

    private hideError = () => {
        this.setState({
            error: null,
        });
    };

    static getDerivedStateFromError(error: Error): GlobalErrorBoundary.State {
        return { error };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error('Uncaught Error:', error, errorInfo);
    }

    componentDidMount() {
        window.addEventListener('unhandledrejection', this.promiseRejectionHandler);
    }

    componentWillUnmount() {
        window.removeEventListener('unhandledrejection', this.promiseRejectionHandler);
    }

    render() {
        return (
            <>
                {this.props.children}
                {this.state.error ? <ErrorDisplay onClose={this.hideError} /> : null}
            </>
        );
    }
}

export namespace GlobalErrorBoundary {
    export interface Props {
        children: React.ReactNode;
    }

    export type State = Readonly<typeof initialState>;
}
